export default __webpack_public_path__ + "static/media/dealsApi.af93875b.png";